<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane
        class="paddingBody content"
        :label="$t('Riesgos pendientes')"
      >
        <i class="el-icon-info" style="margin-right: 10px"></i>
        <b>Días acumulados:</b> Cantidad de días que han transcurrido desde que
        fue recepcionado el riesgo.
        <br />
        <br />
        <center v-if="loading">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-table
          v-if="!loading"
          :cell-class-name="pintar"
          empty-text="No hay riesgos que requieran su revisión"
          :data="paginarRiesgos()"
          style="width: 100%"
          header-cell-class-name="header-cell-class-table-gray"
          stripe
        >
          <el-table-column type="expand" width="40" label="+">
            <template slot-scope="scope">
              <div style="padding-left: 45px">
                <el-table
                  :cell-class-name="pintar"
                  :data="[getRiskById(scope.row.id_riesgo)]"
                  style="width: 100%; border: 10px; border-collapse: separate"
                  header-cell-class-name="header-cell-class-table-gray"
                >
                  <el-table-column type="expand" width="40" label="+">
                    <template slot-scope="props">
                      <el-row
                        :gutter="20"
                        style="
                          padding-left: 20px !important;
                          padding-right: 20px !important;
                        "
                      >
                        <el-col :sm="8">
                          <h4>{{ $t("Causas") }}</h4>
                          <ol
                            v-if="
                              props.row.causas && props.row.causas.length > 0
                            "
                          >
                            <li
                              v-for="(causa, ic) in props.row.causas"
                              :key="ic"
                            >
                              {{ causa.nombre }}
                            </li>
                          </ol>
                          <span class="no-registrado-texto" v-else
                            ><i>{{ $t("No se registraron causas") }}</i></span
                          >
                        </el-col>
                        <el-col :sm="8">
                          <h4>{{ $t("Controles Preventivos") }}</h4>
                          <ol
                            v-if="getControlesPreventivos(props.row).length > 0"
                          >
                            <li
                              v-for="(control, ic) in getControlesPreventivos(
                                props.row
                              )"
                              :key="ic"
                              :class="tablaControlCritico(control)"
                            >
                              {{ control.nombre }}
                            </li>
                          </ol>
                          <span class="no-registrado-texto" v-else
                            ><i>{{
                              $t("No se registraron controles preventivos")
                            }}</i></span
                          >
                        </el-col>
                        <el-col :sm="8">
                          <h4>{{ $t("Controles Mitigatorios") }}</h4>
                          <ol
                            v-if="getControlesMitigadores(props.row).length > 0"
                          >
                            <li
                              v-for="(control, ic) in getControlesMitigadores(
                                props.row
                              )"
                              :key="ic"
                              :class="tablaControlCritico(control)"
                            >
                              {{ control.nombre }}
                            </li>
                          </ol>
                          <span class="no-registrado-texto" v-else
                            ><i>{{
                              $t("No se registraron controles mitigadores")
                            }}</i></span
                          >
                        </el-col>
                      </el-row>
                      <div
                        v-if="props.row.medioambiental || props.row.medioambiente"
                        style="
                          padding-left: 20px !important;
                          padding-right: 20px !important;
                        "
                      >
                        <h2 style="margin-bottom: 0px; font-size: 16px">
                          {{ $t("Información Medioambiental") }}
                        </h2>
                        <el-row :gutter="20">
                          <el-col :sm="12">
                            <h5>{{ $t("Responsable") }}</h5>
                            {{
                              props.row.medioambiente.responsable ||
                              "No Registrado"
                            }}
                            <h5>{{ $t("Condición") }}</h5>
                            {{
                              props.row.medioambiente.condicion ||
                              "No Registrado"
                            }}
                            <h5>{{ $t("Aspecto Ambiental") }}</h5>
                            {{
                              props.row.medioambiente.aspecto || "No Registrado"
                            }}
                          </el-col>
                          <el-col :sm="12">
                            <h5>{{ $t("Evento") }}</h5>
                            {{
                              props.row.medioambiente.evento || "No Registrado"
                            }}
                            <h5>{{ $t("Equipo Crítico") }}</h5>
                            {{
                              props.row.medioambiente.equipo || "No Registrado"
                            }}
                            <h5>{{ $t("Evaluación Aspecto Ambiental") }}</h5>
                            <el-tag
                              :type="
                                getMayorImpacto(props.row).mfl >= 3
                                  ? 'danger'
                                  : 'success'
                              "
                            >
                              {{
                                getMayorImpacto(props.row).mfl >= 3
                                  ? $t("Significativo")
                                  : $t("No Significativo")
                              }}
                            </el-tag>
                          </el-col>
                        </el-row>
                        <br /><br />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('Riesgo')" min-width="280">
                    <template slot-scope="scope">
                      <div class="nombre-riesgo">{{ scope.row.nombre }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('Tipo Impacto')" width="130">
                    <template slot-scope="scope">
                      <span
                        v-if="
                          getMayorImpacto(scope.row).impacto &&
                          getMayorImpacto(scope.row).impacto.categoria
                        "
                      >
                        {{ getMayorImpacto(scope.row).impacto.categoria }}
                      </span>
                      <el-tooltip
                        v-else
                        class="item"
                        effect="dark"
                        :content="
                          $t('El usuario no asoció ningún impacto al riesgo')
                        "
                        placement="top"
                      >
                        <el-tag type="danger" size="large" effect="plain">{{
                          $t("No registrado")
                        }}</el-tag>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="MFL"
                    prop="mfl"
                    width="100"
                    align="center"
                    sortable
                  >
                    <template slot-scope="scope">
                      <el-popover
                        v-if="getMayorImpacto(scope.row).impacto"
                        placement="top-start"
                        width="400"
                        trigger="hover"
                        :content="
                          nivelSeveridad[getMayorImpacto(scope.row).mfl]
                            ? nivelSeveridad[getMayorImpacto(scope.row).mfl][
                                validarTipoImpacto(scope.row)
                              ]
                            : ''
                        "
                      >
                        <div
                          slot="reference"
                          class="full-content"
                          v-bind:type="mflRange(getMayorImpacto(scope.row).mfl)"
                        >
                          {{ getMayorImpacto(scope.row).mfl }}
                        </div>
                      </el-popover>

                      <div
                        v-else
                        class="full-content no-aplica"
                        v-bind:type="mflRange(getMayorImpacto(scope.row).mfl)"
                      >
                        {{ getMayorImpacto(scope.row).mfl }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="FS" align="center" width="100">
                    <template slot-scope="scope">
                      <el-popover
                        v-if="getMayorImpacto(scope.row).impacto"
                        placement="top-start"
                        width="800"
                        trigger="hover"
                        :content="
                          factorSeveridad[
                            getMayorImpacto(scope.row).impacto.factor_severidad
                          ] &&
                          factorSeveridad[
                            getMayorImpacto(scope.row).impacto.factor_severidad
                          ][validarTipoImpacto(scope.row)]
                            ? factorSeveridad[
                                getMayorImpacto(scope.row).impacto
                                  .factor_severidad
                              ][validarTipoImpacto(scope.row)]
                            : ''
                        "
                      >
                        <div class="full-content" slot="reference">
                          {{
                            getMayorImpacto(scope.row).impacto.factor_severidad
                          }}
                        </div>
                      </el-popover>

                      <div v-else class="no-aplica">-</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="FP" align="center" width="100">
                    <template slot-scope="scope">
                      <el-popover
                        v-if="getMayorImpacto(scope.row).impacto"
                        placement="top-start"
                        width="400"
                        trigger="hover"
                        :content="
                          probabilidades[
                            getMayorImpacto(scope.row).impacto
                              .factor_probabilidad
                          ] &&
                          probabilidades[
                            getMayorImpacto(scope.row).impacto
                              .factor_probabilidad
                          ]['value']
                            ? probabilidades[
                                getMayorImpacto(scope.row).impacto
                                  .factor_probabilidad
                              ]['value']
                            : ''
                        "
                      >
                        <div class="full-content" slot="reference">
                          {{
                            getMayorImpacto(scope.row).impacto
                              .factor_probabilidad
                          }}
                        </div>
                      </el-popover>

                      <div v-else class="no-aplica">-</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="RRR" align="center" width="100">
                    <template slot-scope="scope">
                      <span>{{ getMayorImpacto(scope.row).rrr }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="NSR" align="center" width="110">
                    <template slot-scope="scope">
                      <span
                        v-if="
                          getMayorImpacto(scope.row).impacto &&
                          getMayorImpacto(scope.row).impacto.nivel_severidad
                        "
                      >
                        {{ getMayorImpacto(scope.row).impacto.nivel_severidad }}
                      </span>
                      <el-tag
                        type="danger"
                        size="large"
                        effect="plain"
                        v-else
                        >{{ $t("No registrado") }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('Último Estado')"
                    align="center"
                    width="215"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="
                          scope.row.custom &&
                          $store.getters.inventario.status != 3
                        "
                      >
                        <el-tag
                          type="warning"
                          size="small"
                          v-if="
                            scope.row.status == 0 && scope.row.status_step != -1
                          "
                          >{{ $t("En Revisión") }}</el-tag
                        >
                        <el-tag
                          size="small"
                          v-if="
                            scope.row.status == 0 && scope.row.status_step == -1
                          "
                          type="danger"
                          >{{ $t("Necesita arreglo") }}</el-tag
                        >
                        <el-tag
                          size="small"
                          type="success"
                          v-if="scope.row.status == 1"
                          >{{ $t("Aprobado") }}</el-tag
                        >
                        <p
                          v-if="scope.row.status_by"
                          class="statusUpdatedAt"
                          :title="
                            $t('Persona que revisó riesgo por última vez')
                          "
                        >
                          <span style="font-size: 12px">
                            <b>Últimos revisores</b>
                          </span>
                          <br />
                          <i class="el-icon-d-arrow-right"></i>
                          {{ getPerfil(scope.row.status_position) }}
                          <br />
                          {{ scope.row.status_by }}
                          <br />
                          {{
                            scope.row.status_updated_at
                              | moment("DD MMM YYYY HH:mm")
                          }}
                        </p>
                      </div>
                      <div v-else class="no-aplica">{{ $t("No aplica") }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Comentarios" width="300">
                    <template slot-scope="scope">
                      <div v-if="scope.row.custom">
                        <div
                          @click="verComentarios(scope.row.status_message)"
                          v-if="scope.row.status_message"
                          style="
                            max-height: 200px;
                            overflow: auto;
                            cursor: pointer;
                          "
                        >
                          <p
                            style="font-size: 12px"
                            v-html="scope.row.status_message"
                          ></p>
                        </div>
                        <span class="no-aplica" v-else>{{
                          $t("Sin comentarios")
                        }}</span>
                      </div>
                      <div v-else class="no-aplica">{{ $t("No aplica") }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="nombre_contrato"
            label="Nombre del inventario"
          ></el-table-column>
          <el-table-column
            prop="tarea_nombre"
            label="Nombre de la tarea"
          ></el-table-column>
          <el-table-column
            prop="nombre_riesgo"
            label="Nombre del riesgo"
          ></el-table-column>
          <el-table-column
            sortable
            prop="dias_acumulados"
            label="Días acumulados"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="Operaciones"
            width="330"
            align="center"
            v-if="!$store.getters.user.readonly"
          >
            <template slot-scope="scope">
              <el-button
                v-if="
                  $store.getters.role.admin ||
                  ($store.getters.role.role !== 'coordinator' &&
                    $store.getters.role.role !== 'contractor_coordinator')
                "
                @click="openDialogVerificarEstado(scope.row)"
                type="primary"
                size="small"
                >Revisar</el-button
              >
              <el-button
                @click="openEditRisk(scope.row)"
                v-if="
                  $store.getters.role.admin ||
                  $store.getters.role.role === 'coordinator' ||
                  $store.getters.role.role === 'contractor_coordinator'
                "
                type="primary"
                size="small"
                >Modificar</el-button
              >
              <el-button
                size="small"
                v-if="
                  $store.getters.role.admin ||
                  $store.getters.role.role === 'coordinator' ||
                  $store.getters.role.role === 'contractor_coordinator'
                "
                icon="el-icon-delete"
                type="danger"
                class="buttonAction"
                @click="deleteRisk(scope.row)"
                >{{ $t("Eliminar") }}</el-button
              >
              <el-button
                style="margin-top: 7px"
                size="small"
                v-if="
                  $store.getters.role.admin ||
                  $store.getters.role.role === 'coordinator' ||
                  $store.getters.role.role === 'contractor_coordinator'
                "
                icon="el-icon-refresh"
                type="primary"
                class="buttonAction"
                @click="openChangeEstandarizado(scope.row)"
              >
                {{ $t("Cambiar por estandarizado") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <br />
        <br />
        <center :class="{ 'display-none': loading }">
          <el-pagination
            @prev-click="backPage"
            @next-click="nextPage"
            @current-change="currentPage"
            :page-size="4"
            layout="prev, pager, next"
            :total="
              $store.getters.riesgos_pendientes.risks
                ? $store.getters.riesgos_pendientes.risks.length
                : 0
            "
          ></el-pagination>
        </center>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      top="10px"
      v-if="actualRisk"
      :before-close="handleClose"
      :title="$t('Modificando Riesgo o Aspecto Ambiental')"
      width="90%"
      :visible="dialogChangeRiskVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <p>
        {{
          $t(
            "A continuación puede modificar el riesgo según lo indicado por el revisor. Por favor, verifique bien antes de guardar."
          )
        }}
      </p>
      <center v-if="loading_risk">
        <br />
        <br />
        <Circle9 style="margin-bottom: 8px"></Circle9>
        <small>Cargando Datos ...</small>
        <br />
        <br />
      </center>
      <InventarioBowtie
        v-else
        :dataHistory="[]"
        :editable="true"
        :risk="actualRisk"
        :addCause="addCause"
        :deleteCause="deleteCause"
        :editCause="editCause"
        :addImpact="addImpact"
        :deleteImpact="deleteImpact"
        :editImpact="editImpact"
        :addPreventiveControl="addPreventiveControl"
        :deletePreventiveControl="deletePreventiveControl"
        :editPreventiveControl="editPreventiveControl"
        :addMitigationControl="addMitigationControl"
        :deleteMitigationControl="deleteMitigationControl"
        :editMitigationControl="editMitigationControl"
        :addEvaluator="addEvaluator"
        :deleteEvaluator="deleteEvaluator"
        :editEvaluator="editEvaluator"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("Cancelar") }}</el-button>
        <el-button :loading="loading_risk" type="primary" @click="saveRisk()">{{
          $t("Guardar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="30%"
      :title="$t('REVISIÓN')"
      :visible="dialogVerificarEstado"
      :before-close="handleClose"
    >
      <el-form :model="status">
        <div>
          <el-form-item :label="$t('Estado')">
            <el-select
              :class="{
                aprueba: status.status_step === true,
                rechaza: status.status_step === false,
              }"
              v-model="status.status_step"
              :placeholder="$t('Por favor revise el riesgo')"
              size="large"
              class="with-help-box fullWidth"
            >
              <el-option
                style="background-color: green; color: white"
                :label="$t('Revisado (Aprobar)')"
                :value="true"
              >
              </el-option>
              <el-option
                style="background-color: red; color: white"
                :label="$t('Revisado con comentarios (Rechazar)')"
                :value="false"
              ></el-option>
            </el-select>
            <el-popover
              class="help-box"
              placement="top"
              :title="$t('Estado')"
              width="200"
              trigger="hover"
              :content="
                $t(
                  'Seleccione el estado de aprobación del riesgo. Si no aprueba la evaluación del riesgo, debe seleccionar \'Revisado con comentarios\'.'
                )
              "
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item
            :label="$t('Seleccione observaciones')"
            v-if="status.status_step === false"
          >
            <el-select
              class="with-help-box fullWidth"
              v-model="acciones"
              multiple
              placeholder="Seleccione observaciones"
            >
              <el-option
                v-for="item in opciones_comentarios"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="Observaciones adicionales"
            v-if="status.status_step === false"
          >
            <el-input
              class="with-help-box"
              type="textarea"
              :rows="2"
              v-model="status.message"
            />
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("Cancelar") }}</el-button>
        <el-button type="primary" @click="evaluar()">{{
          $t("Guardar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Historial de comentarios"
      :visible.sync="openDialogComentario"
      width="30%"
      :before-close="handleClose"
    >
      <div style="height: 400px; overflow: auto; margin-top: 20px">
        <p v-html="comentario"></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openDialogComentario = false">Cerrar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Sustituir por estandarizado"
      :visible.sync="dialogChangeEstandarizado"
      width="40%"
      :before-close="handleClose"
    >
      <el-table
        height="400"
        :data="$store.getters.allRisks"
        style="width: 100%"
      >
        <el-table-column width="150" label="Acciones">
          <template slot-scope="scope">
            <el-button
              size="small"
              @click="changeRiskEstandarizado(scope.row)"
              type="warning"
              >Seleccionar</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="Faena" width="170">
          <template slot-scope="scope">
            {{ faenas[$store.getters.role.faena_id] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="nombre"
          label="Nombre del riesgo"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogChangeEstandarizado = false"
          >Cancelar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import axios from "axios";
import moment from "moment-timezone";
import Vue from "vue";
import uuid from "uuid/v4";
import {
  probabilidades,
  nivelSeveridad,
  factorSeveridad,
} from "@/lang/tableInformation.js";
import InventarioBowtie from "@/components/InventarioBowtie.vue";

export default {
  data() {
    return {
      loading_risk: false,
      faenas: {
        "5a6f78337b772dcfe68241d5": "Minera Escondida",
        "5a6f78417b772dcfe68241e5": "Minera Spence",
        "5a6f784e7b772dcfe68241f4": "Minera Cerro Colorado",
        "5b48f15d6f0ed90fc02826e3": "BHP",
        "5c262b3176851b775b8bdefc": "Safety Club",
      },
      factorSeveridad,
      nivelSeveridad,
      probabilidades,
      loading: false,
      roles: {
        superadmin: "Superadministrador",
        super: "Superintendente",
        manager: "Gerente",
        contractor_coordinator: "Coordinador contratista",
        contractor_hse: "HSE Contratista",
        administrator: "Administrador de contratos",
        coordinator: "Coordinador",
        owner: "Dueño de contrato",
        risk: "Especialista de riesgos",
        hse: "HSE",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
      },
      acciones: [],
      opciones_comentarios: [
        {
          value: "Cambiar nombre a riesgo estandarizado",
          label: "Cambiar nombre a riesgo estandarizado",
        },
        {
          value: "Cambiar, (subir o bajar) nivel de MFL",
          label: "Cambiar, (subir o bajar) nivel de MFL",
        },
        {
          value: "Incluir control mitigador",
          label: "Incluir control mitigador",
        },
        {
          value: "Incluir control preventivo",
          label: "Incluir control preventivo",
        },
        {
          value: "Controles no cubren todas las causas",
          label: "Controles no cubren todas las causas",
        },
        {
          value: "No es causa",
          label: "No es causa",
        },
        {
          value: "No es control",
          label: "No es control",
        },
        {
          value: "No es riesgo",
          label: "No es riesgo",
        },
        {
          value: "Otro",
          label: "Otro",
        },
      ],
      status: {
        status_step: true,
        message: "",
      },
      dialogVerificarEstado: false,
      riesgo_pendiente: {},
      page: 1,
      actualRisk: null,
      risk_copy: {},
      dialogChangeRiskVisible: false,
      inventario_id: "",
      tarea_id: "",
      all_risks: [],
      openDialogComentario: false,
      comentario: "",
      riskPerChange: {},
      dialogChangeEstandarizado: false,
    };
  },
  created() {
    if (!this.$store.getters.riesgos_pendientes) {
      this.$router.push({ name: "dashboardPersonal" });
    }
    this.$store.dispatch("setSubTitle", "Listado de riesgos pendientes");
    this.getAllRisks();
    this.$store.dispatch("getAllRisks");
    if (this.hasTutorial() === false) {
      this.$alert(
        "Sección de evaluación de riesgos, según selección anterior. Se listarán riesgos con más de 10 días o menos de 10 días de estado en su cuenta. Estos riesgos se podrán evaluar o corregir dependiendo de su perfil, como revisor o coordinator. Para más información puede oprimir el botón detalles para visualizar todos los datos del riesgo.",
        "Información Importante",
        {
          confirmButtonText: "Aceptar",
          callback: (action) => {
            this.$confirm(
              "¿Desea ocultar este tutorial en sus próximas sesiones?",
              "Información",
              {
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                type: "warning",
              }
            ).then(() => {
              localStorage.setItem("tutorial_2", "true");
            });
          },
        }
      );
    }
    if (localStorage.getItem("tutorial_2") === "false") {
      localStorage.setItem("tutorial_2", "false");
    }
  },
  components: {
    InventarioBowtie,
    Circle9,
  },
  methods: {
    // REINCORPORADO: Método para abrir el modal de revisión de estados
    openDialogVerificarEstado(riesgo) {
      this.riesgo_pendiente = riesgo;
      this.dialogVerificarEstado = true;
    },
    changeRiskEstandarizado(estandarizado) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      this.$confirm(
        `Estas a punto de sustituir el riesgo "${this.riskPerChange.nombre_riesgo}" por el riesgo estandarizado "${estandarizado.nombre}", ¿Deseas continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(async () => {
        this.dialogChangeEstandarizado = false;
        this.loading = true;
        const self = this;
        axios
          .post(
            "/inventarios/cambiarEstandarizado",
            {
              id_inv: this.riskPerChange.inv_id,
              task_id: this.riskPerChange.tarea_id,
              risk_id: this.riskPerChange.id_riesgo,
              riesgo: estandarizado,
            },
            config
          )
          .then(async (response) => {
            if (response.data.success === true) {
              await self.getStatus();
              self.getAllRisks();
              self.$notify({
                title: "Información",
                message: "Riesgo sustituido exitosamente.",
                type: "success",
              });
              self.loading = false;
            }
          });
      });
    },
    openChangeEstandarizado(risk) {
      this.riskPerChange = JSON.parse(JSON.stringify(risk));
      this.dialogChangeEstandarizado = true;
    },
    async deleteRisk(risk) {
      this.$confirm(
        `Estas a punto de eliminar el riesgo "${risk.nombre_riesgo}", ¿Deseas continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(async () => {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
        var self = this;
        axios
          .post(
            "/inventarios/delete-risk",
            {
              inventory_id: risk.inv_id,
              task_id: risk.tarea_id,
              risk: {
                _id: risk.id_riesgo,
              },
            },
            config
          )
          .then(async (response) => {
            if (response.data.success === true) {
              self.loading = true;
              await self.getStatus();
              self.getAllRisks();
              self.$notify({
                title: "Información",
                message: "Riesgo eliminado exitosamente.",
                type: "success",
              });
              self.loading = false;
            }
          });
      });
    },
    hasTutorial() {
      if (localStorage.getItem("tutorial_2") === "true") {
        return true;
      }
      return false;
    },
    verComentarios(comentario) {
      this.openDialogComentario = true;
      this.comentario = comentario;
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    getPerfil(profile) {
      return this.roles[profile] || "";
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr = 0;
      let mayorImpacto = {
        categoria: "",
        factor_severidad: 0,
        factor_probabilidad: 0,
        nivel_severidad: "",
      };

      if (risk && risk.impactos && risk.impactos.length > 0) {
        mayorImpacto = risk.impactos[0];
        mfl = mayorImpacto.mfl || 0;
        rrr =
          ((mayorImpacto.factor_severidad || 0) *
            10 *
            ((mayorImpacto.factor_probabilidad || 0) * 10)) /
          100;

        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            mfl = impacto.mfl;
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              100;
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    getControlesPreventivos(risk) {
      const controles = [];
      const controlesId = {};

      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const id = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach((control) => {
              if (!controlesId[control.nombre]) {
                controlesId[control.nombre] = true;
                control.id_causa = id;
                controles.push(control);
              }
            });
          }
        });
      }

      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];

      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;

          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              controles.push(control);
            });
          }
        });
      }

      return controles;
    },
    getRiskById(id) {
      return this.all_risks.find((x) => x._id === id || x.id === id);
    },
    getAllRisks() {
      this.loading = true;
      const self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      axios
        .post("/inventarios/getAllRisk", this.paginarRiesgos(), config)
        .then((response) => {
          self.loading = false;
          self.all_risks = response.data;
        })
        .catch((error) => {
          self.loading = false;
          console.log(error);
        });
    },
    pintar({ row, column, rowIndex, columnIndex }) {
      let classes = "cellClassTablaPloma ";
      if (columnIndex === 0) {
        if (row.tipo.toLowerCase() === "seguridad") {
          classes += "colorSeguridad";
        } else if (row.tipo.toLowerCase() === "salud") {
          classes += "colorSalud";
        } else if (
          row.tipo.toLowerCase() === "salud y seguridad" &&
          !row.custom
        ) {
          classes += "colorSaludySeguridad";
        } else if (row.tipo.toLowerCase() === "medioambiente") {
          classes += "colorMedioambiente";
        } else {
          classes += "sinTipo";
        }
      }
      return classes;
    },
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    validarTipoImpacto(risk) {
      if (
        this.getMayorImpacto(risk).impacto.categoria.toLowerCase() ===
        "salud y seguridad"
      ) {
        return "seguridad";
      }
      return this.getMayorImpacto(risk).impacto.categoria.toLowerCase();
    },
    saveRisk() {
      if (JSON.stringify(this.actualRisk) === JSON.stringify(this.risk_copy)) {
        this.$confirm(
          this.$t(
            "No has realizado ningún cambio en el riesgo, estás seguro que deseas continuar?"
          ),
          this.$t("Atención"),
          { type: "warning" }
        ).then(() => {
          this.updateRisk();
        });
      } else {
        this.updateRisk();
      }
    },
    updateRisk() {
      this.$confirm(
        this.$t(
          "Estos cambios serán sujetos a revisión. ¿Está seguro de continuar?"
        ),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        this.loading_risk = true;
        this.actualRisk.status = 0;
        this.actualRisk.status_step = 0;
        this.actualRisk.status_by = this.username();
        this.actualRisk.status_position = this.$store.getters.role.role;

        this.actualRisk.status_history = [[]];
        this.$store
          .dispatch("updateRiskReviewed", {
            inventory_id: this.inventario_id,
            task_id: this.tarea_id,
            risk: this.actualRisk,
            username: this.username(),
            admin: this.$store.getters.role.admin,
            role: this.roles[this.$store.getters.role.role],
          })
          .then(async (response) => {
            if (response.status === true) {
              await this.getStatus();
              this.$alert(
                this.$t(
                  "Riesgo actualizado y enviado a aprobación exitosamente."
                ),
                this.$t("Atención"),
                {
                  type: "success",
                }
              );
              this.handleClose();
            } else {
              this.$alert(
                this.$t(
                  "Lo sentimos, surgió un error al actualizar el riesgo. Intente nuevamente."
                ),
                this.$t("Atención"),
                {
                  type: "error",
                }
              );
              this.loading_risk = false;
            }
          });
      });
    },
    addCause(causa) {
      const cause = {
        id: uuid(),
        nombre: causa,
      };
      this.actualRisk.causas.push(cause);
    },
    deleteCause(causaId) {
      const causeIndex = this.actualRisk.causas.findIndex(
        (cause) => cause.id === causaId
      );
      Vue.delete(this.actualRisk.causas, causeIndex);
    },
    editCause(causa, causaID) {
      const causeIndex = this.actualRisk.causas.findIndex(
        (cause) => cause.id === causaID
      );
      Vue.set(this.actualRisk.causas, causeIndex, {
        ...this.actualRisk.causas[causeIndex],
        nombre: causa,
      });
    },
    addImpact(impacto) {
      const impact = {
        id: uuid(),
        ...impacto,
      };
      this.actualRisk.impactos.push(impact);
    },
    deleteImpact(impactoId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        (impact) => impact.id === impactoId
      );
      Vue.delete(this.actualRisk.impactos, impactIndex);
    },
    editImpact(impacto, impactoId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        (impact) => impact.id === impactoId
      );
      Vue.set(this.actualRisk.impactos, impactIndex, {
        ...this.actualRisk.impactos[impactIndex],
        categoria: impacto.categoria,
        descripcion: impacto.descripcion,
        factor_severidad: impacto.factor_severidad,
        factor_probabilidad: impacto.factor_probabilidad,
        nivel_severidad: impacto.nivel_severidad,
        mfl: impacto.mfl,
      });
    },
    addPreventiveControl(causasId, control) {
      causasId.forEach((causaId) => {
        const causeIndex = this.actualRisk.causas.findIndex(
          (cause) => cause.id === causaId
        );
        if (!this.actualRisk.causas[causeIndex].controles_preventivos) {
          Vue.set(this.actualRisk.causas, causeIndex, {
            ...this.actualRisk.causas[causeIndex],
            controles_preventivos: [],
          });
        }
        const controlPreventivo = {
          id: uuid(),
          nombre: control,
        };
        this.actualRisk.causas[causeIndex].controles_preventivos.push(
          controlPreventivo
        );
      });
    },
    deletePreventiveControl(causaId, controlId) {
      const causeIndex = this.actualRisk.causas.findIndex(
        (cause) => cause.id === causaId
      );
      const controlIndex = this.actualRisk.causas[
        causeIndex
      ].controles_preventivos.findIndex((control) => control.id === controlId);
      Vue.delete(
        this.actualRisk.causas[causeIndex].controles_preventivos,
        controlIndex
      );
    },
    editPreventiveControl(control, controlId) {
      this.actualRisk.causas.forEach((cause, causeIndex) => {
        let controlIndex = -1;
        if (cause.controles_preventivos) {
          controlIndex = cause.controles_preventivos.findIndex(
            (control) => control.id === controlId
          );
        }

        if (control.causas.includes(cause.id)) {
          if (controlIndex >= 0) {
            Vue.set(
              this.actualRisk.causas[causeIndex].controles_preventivos,
              controlIndex,
              {
                ...this.actualRisk.causas[causeIndex].controles_preventivos[
                  controlIndex
                ],
                nombre: control.nombre,
                critico: control.critico,
              }
            );
          } else {
            const controlPreventivo = {
              id: controlId,
              nombre: control.nombre,
              critico: control.critico,
            };
            if (!this.actualRisk.causas[causeIndex].controles_preventivos) {
              Vue.set(this.actualRisk.causas, causeIndex, {
                ...this.actualRisk.causas[causeIndex],
                controles_preventivos: [],
              });
            }
            this.actualRisk.causas[causeIndex].controles_preventivos.push(
              controlPreventivo
            );
          }
        } else if (controlIndex >= 0) {
          Vue.delete(
            this.actualRisk.causas[causeIndex].controles_preventivos,
            controlIndex
          );
        }
      });
    },
    addMitigationControl(impactoId, control) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        (impact) => impact.id === impactoId
      );
      if (!this.actualRisk.impactos[impactIndex].controles_mitigadores) {
        Vue.set(this.actualRisk.impactos, impactIndex, {
          ...this.actualRisk.impactos[impactIndex],
          controles_mitigadores: [],
        });
      }
      const controlMitigador = {
        id: uuid(),
        nombre: control,
      };
      this.actualRisk.impactos[impactIndex].controles_mitigadores.push(
        controlMitigador
      );
    },
    deleteMitigationControl(impactoId, controlId) {
      const impactIndex = this.actualRisk.impactos.findIndex(
        (impact) => impact.id === impactoId
      );
      const controlIndex = this.actualRisk.impactos[
        impactIndex
      ].controles_mitigadores.findIndex((control) => control.id === controlId);
      Vue.delete(
        this.actualRisk.impactos[impactIndex].controles_mitigadores,
        controlIndex
      );
    },
    editMitigationControl(control, controlId) {
      this.actualRisk.impactos.forEach((impact, impactIndex) => {
        let controlIndex = -1;
        if (impact.controles_mitigadores) {
          controlIndex = impact.controles_mitigadores.findIndex(
            (control) => control.id === controlId
          );
        }
        if (control.impacto === impact.id) {
          if (controlIndex >= 0) {
            Vue.set(
              this.actualRisk.impactos[impactIndex].controles_mitigadores,
              controlIndex,
              {
                ...this.actualRisk.impactos[impactIndex].controles_mitigadores[
                  controlIndex
                ],
                nombre: control.nombre,
                critico: control.critico,
              }
            );
          } else {
            const controlMitigador = {
              id: uuid(),
              nombre: control.nombre,
              critico: control.critico,
            };
            this.actualRisk.impactos[impactIndex].controles_mitigadores.push(
              controlMitigador
            );
          }
        } else if (controlIndex >= 0) {
          Vue.delete(
            this.actualRisk.impactos[impactIndex].controles_mitigadores,
            controlIndex
          );
        }
      });
    },
    addEvaluator(pEvaluator) {
      if (!this.actualRisk.evaluadores) {
        this.actualRisk.evaluadores = [];
      }
      const evaluator = {
        ...pEvaluator,
        id: uuid(),
      };
      this.actualRisk.evaluadores.push(evaluator);
    },
    editEvaluator(evaluator, evaluadorId) {
      const evaluatorIndex = this.actualRisk.evaluadores.findIndex(
        (evaluator) => evaluator.id === evaluadorId
      );
      Vue.set(this.actualRisk.evaluadores, evaluatorIndex, {
        ...this.actualRisk.evaluadores[evaluatorIndex],
        nombre: evaluator.nombre,
        rut: evaluator.rut,
        cargo: evaluator.cargo,
        empresa: evaluator.empresa,
      });
    },
    deleteEvaluator(evaluadorId) {
      const evaluatorIndex = this.actualRisk.evaluadores.findIndex(
        (evaluator) => evaluator.id === evaluadorId
      );
      Vue.delete(this.actualRisk.evaluadores, evaluatorIndex);
    },
    currentPage(page) {
      this.page = page;
      this.paginarRiesgos();
      this.getAllRisks();
    },
    backPage(page) {
      this.page = page;
    },
    nextPage(page) {
      this.page = page;
    },
    paginarRiesgos() {
      if (this.$store.getters.riesgos_pendientes.risks) {
        return this.$store.getters.riesgos_pendientes.risks.slice(
          (this.page - 1) * 4,
          this.page * 4
        );
      }
      return [];
    },
    getRiskById(id) {
      return this.all_risks.find((x) => x._id === id || x.id === id);
    },
    async getStatus() {
      const self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const role =
        this.$store.getters.role.admin === true
          ? "superadmin"
          : this.$store.getters.role.role;
      await axios
        .get(
          `/inventarios/getStatusDashboard/${this.$store.getters.role.faena_id}/${role}/${this.$store.getters.user._id}/${this.$store.getters.role.area_id}/${this.$store.getters.role.empresa_id}`,
          config
        )
        .then((response) => {
          self.$store.dispatch("setAllRiesgosPendientes", response.data);
          const estructura =
            self.$store.getters.riesgos_pendientes.structure.split(".");
          const pendientes =
            response.data[estructura[0]][estructura[1]][estructura[2]][
              estructura[3]
            ][estructura[4]];
          self.$store.dispatch("setRiesgosPendientes", {
            risks: pendientes,
            structure: self.$store.getters.riesgos_pendientes.structure,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openEditRisk(risk) {
      this.getRisk(risk.inv_id, risk.tarea_id, risk.id_riesgo);
    },
    getRisk(inv_id, tarea_id, riskid) {
      this.inventario_id = inv_id;
      this.tarea_id = tarea_id;
      const self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      axios
        .get(`/inventarios/getRisk/${inv_id}/${tarea_id}/${riskid}`, config)
        .then((response) => {
          if (response.data.tipo.toLowerCase() === "medioambiente") {
            if (!response.data.medioambiente) {
              response.data["medioambiente"] = {};
              response.data["medioambiente"]["responsable"] = "";
              response.data["medioambiente"]["evento"] = "";
              response.data["medioambiente"]["condicion"] = "";
              response.data["medioambiente"]["equipo"] = "";
            }
          }
          self.actualRisk = JSON.parse(JSON.stringify(response.data));
          self.risk_copy = JSON.parse(JSON.stringify(response.data));
          if (!self.actualRisk.medioambiente) {
            self.actualRisk.medioambiente = {};
          }
          self.dialogChangeRiskVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    tablaControlCritico(risk) {
      if (risk && risk.critico) {
        return "control-critico";
      }
      return "";
    },
    handleClose() {
      this.loading_risk = false;
      this.dialogChangeEstandarizado = false;
      this.riskPerChange = {};
      this.openDialogComentario = false;
      this.dialogVerificarEstado = false;
      this.dialogChangeRiskVisible = false;
      this.actualRisk = null;
      this.risk_copy = {};
      this.inventario_id = "";
      this.tarea_id = "";
      this.comentario = "";
      this.status = {
        status_step: true,
        message: "",
      };
    },
    async evaluar() {
      if (
        this.status.status_step === false &&
        (this.acciones.length === 0 || this.status.message === "")
      ) {
        this.$alert(
          this.$t(
            "Lo sentimos, debe completar todos los campos solicitados para continuar. Intente nuevamente."
          ),
          this.$t("Atención"),
          {
            type: "warning",
          }
        );
      } else {
        const self = this;
        this.loading = true;
        this.riesgo_pendiente.user = {
          nombre: this.$store.getters.user.nombre,
          apellido: this.$store.getters.user.apellido,
        };
        this.riesgo_pendiente.role = {
          role: this.$store.getters.role.admin
            ? "superadmin"
            : this.$store.getters.role.role,
          isAdmin: !!this.$store.getters.role.admin,
        };
        this.riesgo_pendiente.status = {
          status_step: this.status.status_step,
          message: this.status.message,
          acciones: this.acciones,
        };
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
        await axios
          .post("/inventarios/updateRisk", this.riesgo_pendiente, config)
          .then(async (response) => {
            if (response.data.success) {
              self.handleClose();
              await self.getStatus();
              this.status = {
                status_step: true,
                message: "",
              };
              self.acciones = [];
              self.$notify({
                title: "Información",
                message: response.data.message,
                type: "success",
              });
              self.loading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
};
</script>

<style scoped>
.control-critico {
  color: #f56c6c !important;
  font-weight: bold !important;
}

.aprueba {
  border: 3px solid green;
  color: white;
}

.rechaza {
  border: 3px solid red;
  color: white;
}

.display-none {
  display: none;
}

.fullWidth {
  width: 100%;
}

.statusUpdatedAt {
  font-size: 10px;
  color: gray;
}

.nombre-riesgo {
  word-break: break-word;
}

.no-aplica {
  font-size: 12px;
  color: gray;
}

.green {
  background-color: #6bc45b;
}

.full-content {
  width: 100%;
}

.no-registrado-texto {
  font-size: 13px;
  color: #909399;
  display: inline-block;
  margin-top: 5px;
}
</style>

<style>
.el-table__expanded-cell[class*="cell"] {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
